/**
 * Created by fworld on 2019/9/25.
 */
import request from '@/util/request'

export const deviceUnion = (params) => {
    return request({
        'url': '/api/v1/delivery/device/union',
        'method': 'GET',
        params
    })
}

export const deviceCnt = (params) => {
  return request({
    'url': '/api/v1/delivery/device/cnt',
    'method': 'GET',
    params
  })
}

export const deviceDelete = (params) => {
  return request({
    'url': '/api/v1/delivery/device/delete',
    'method': 'GET',
    params
  })
}

export const deviceList = (params) => {
    return request({
        'url': '/api/v1/delivery/device/list',
        'method': 'GET',
        params
    })
}


export const deviceSearch = (params) => {
    return request({
        'url': '/api/v1/delivery/device/search',
        'method': 'GET',
        params
    })
}

export const devicePositionUpdate = (data) => {
    return request({
        'url': '/api/v1/delivery/device/position/update',
        'method': 'POST',
        data
    })
}

export const deviceAll = () => {
    return request({
        'url': '/api/v1/delivery/device/all',
        'method': 'get',
    })
}

export function downloadHistory(data) {
    return request({
        url: '/api/v1/delivery/down/history',
        method: 'post',
        data
    })
}
